import React from 'react'
import { Label, Message } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import PhoneInput from 'react-phone-number-input'
import { MIN_PHONE_DIGITS, MAX_PHONE_DIGITS } from '../../utils/kegCollectionFormUtils'

const setDigitCountColor = count => {
  if (count === 0) return undefined
  if (count <= MIN_PHONE_DIGITS) return 'yellow'
  if (count >= MAX_PHONE_DIGITS) return 'red'
  return 'green'
}

function KegCollectionPhoneInput(props) {
  const { formValues, onChange, validationErrors, isDisabled, selectedCountry } = props
  const { t: translate } = useTranslation()

  return (
    <>
      <PhoneInput
        // Force re-mount when country changes by changing key
        key={selectedCountry || 'default'}
        disabled={isDisabled}
        value={formValues.phoneNumber}
        onChange={value => onChange(value)}
        country={selectedCountry || undefined}
        flagsPath="https://flagicons.lipis.dev/flags/4x3/"
      />
      <div style={{ display: 'flex', marginTop: 15 }}>
        <div style={{ width: '50%', paddingLeft: 34 }}>
          {formValues.phoneNumber && (
            <Label basic size="small" color={setDigitCountColor(formValues.phoneNumber.length)}>
              {formValues.phoneNumber}
            </Label>
          )}
        </div>
        <div style={{ textAlign: 'right', width: '50%' }}>
          <Label basic size="small" color={setDigitCountColor(formValues.phoneNumber.length)}>
            {formValues.phoneNumber.length} {translate('digits')}
          </Label>
        </div>
      </div>
      {validationErrors.phoneNumber && (
        <Message
          negative
          size="small"
          style={{ marginTop: 10 }}
          content={validationErrors.phoneNumber}
        />
      )}
    </>
  )
}

export default React.memo(KegCollectionPhoneInput)
